import { callAPI } from "./core";

async function getCompany(companyId) {
  return await callAPI(`/company/${companyId}`, "GET", null, true);
}

async function getCompanyUsers(companyId) {
  return await callAPI(`/company/${companyId}/users`, "GET", null, true);
}

async function getCompanyFacilities(companyId) {
  return await callAPI(`/company/${companyId}/facilities`, "GET", null, true);
}

async function getCompanyPricing(companyId) {
  return await callAPI(`/company/${companyId}/pricing`, "GET", null, true);
}

async function getCompanyPayments(companyId) {
  return await callAPI(`/company/${companyId}/payments`, "GET", null, true);
}

async function setCompanyUnclaimedBasic(companyId) {
  return await callAPI(
    `/company/${companyId}/set-unclaimed-basic`,
    "POST",
    null,
    true
  );
}

async function deleteCompany(companyId) {
  return await callAPI(`/company/${companyId}`, "DELETE", null, true);
}

async function listCompanies(page, size, query) {
  let params = {
    page: page,
    size: size
  };
  if (query != null && query.length > 0) {
    params.query = query;
  }

  return await callAPI("/company", "GET", params, true);
}

export {
  getCompany,
  getCompanyUsers,
  getCompanyFacilities,
  getCompanyPayments,
  getCompanyPricing,
  setCompanyUnclaimedBasic,
  deleteCompany,
  listCompanies
};
